import React, { useEffect, useState } from "react";
import { Chart as ChartJS, registerables } from "chart.js";
import { Bar } from "react-chartjs-2";
import { getArticleHourlyStats } from "../../../api/statistics/article/ArticleStatisticsAPI";
import { useSnackbar } from "notistack";
import { singleField } from "../../../util/ArrayUtil";
import { useTranslation } from "react-i18next";
import { errorNoti } from "../../../util/SnackbarMessage";

ChartJS.register(...registerables);

type ChartProps = {
  day: number;
};

function HourlyChartWrapper(props: ChartProps) {
  const { t } = useTranslation(["common", "error"]);
  const [dailyData, setDailyData] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    getArticleHourlyStats(props.day)
      .then((res) => setDailyData(res))
      .catch((err) => {
        var noti = errorNoti(err);
        enqueueSnackbar(t("error:" + noti.message), noti.option);
      });
  }, []);

  const dailyLabels = dailyData.map(function (data) {
    return data["hour"] + ":00";
  });

  return (
    <Bar
      data={{
        labels: dailyLabels,
        datasets: [
          {
            label: "Tổng số bài báo thu thập được",
            backgroundColor: "#48B0F7",
            data: singleField(dailyData, "count"),
          },
        ],
      }}
      options={{
        plugins: {
          legend: { display: false },
          title: {
            display: true,
            text:
              "Số bài báo thu thập được theo khung giờ (" +
              props.day +
              " ngày gần nhất)",
          },
        },
      }}
    />
  );
}

export default HourlyChartWrapper;
